
    import { defineComponent, PropType } from "vue"

    export interface IBreadcrumb {
        name: string
        link: string
    }
    export default defineComponent({
        props: {
            items: Array as PropType<IBreadcrumb[]>,

        },
        components: {

        },
        // emits: ['update:modelValue'], this.$emit('update:modelValue', title)
        data() {
            return {

            }
        },
        computed: {

        },
        methods: {

        },
    })

    